<template>
  <div id="printArea">
    <!-- Kop & logo (print) -->
    <div class="print-only header text-center">
      <table class="w-full border-collapse" style="width: 100%; border-collapse: collapse">
        <tbody>
          <tr class="border-b border-transparent">
            <td class="text-center">
              <img
                src="../../../../public/img/hotel-deliriver.png"
                alt="Deli River Hotel Logo"
                style="width: 50px; height: auto"
              />
            </td>
          </tr>
          <tr class="border-b border-transparent">
            <td class="text-center">
              <h3>Deli River Hotel</h3>
              <p>Jl. Raya Namorambe No. 129, Medan, Indonesia</p>
              <p>www.hotel-deliriver.com</p>
              <p>contact@hotel-deliriver.com</p>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </div>

    <!-- Title -->
    <h3 class="text-center mb-3">
      Imigration Guests Report
    </h3>

    <p class="text-center mb-4">
      Date Range: {{ getFormattedDate(startDate) }} – {{ getFormattedDate(endDate) }}
    </p>

    <!-- Table -->
    <div class="table-print">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>No.</th>
            <th>Guest Name</th>
            <th>Country</th>
            <th>Passport Number</th>
            <th>CheckIn Date</th>
            <th>CheckOut Date</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in guests" :key="i">
            <td class="text-center">{{ i + 1 }}</td>
            <td>{{ item.reservation?.guest?.fullname }}</td>
            <td>{{ item.reservation?.guest?.nationality }}</td>
            <td>{{ item.reservation?.guest?.identity_number }}</td>
            <td class="text-center">{{ getFormattedDate(item.check_in_date) }}</td>
            <td class="text-center">{{ getFormattedDate(item.check_out_date) }}</td>
            <td class="text-center">{{ item.reservation?.days }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Summary -->
    <p class="area-print mt-4">
      Total Foreign Guests: {{ guests.length }}
    </p>
  </div>
</template>

<script setup>
  import { inject, ref, onMounted, nextTick } from "vue";
  import { useRoute } from "vue-router";
  import { getFormattedDate } from "@/composable/getDateTimeFormatter";

  const route = useRoute();

  // 🔹 PAKAI CARA SAMA DENGAN INDEX
  const repositories = inject("repositories");
  const checkinRepository = repositories?.checkin;

  const startDate = route.query.start_date;
  const endDate = route.query.end_date;

  const guests = ref([]);

  const fetchData = async () => {
    const params = {};

    if (startDate) params.start = startDate;
    if (endDate) params.end = endDate;

    console.log("PRINT PARAMS:", params);

    const res = await checkinRepository.getListCheckout(params);

    // 🔹 FILTER SAMA PERSIS DENGAN INDEX
    guests.value = (res.data.data || []).filter(
      item => item.reservation?.guest?.nationality !== "Indonesia"
    );

    console.log("PRINT DATA:", guests.value);
  };

  onMounted(async () => {
    await fetchData();
    await nextTick();
    handlePrint();
  });

  const handlePrint = () => {
    const printArea = document.getElementById("printArea");
    if (!printArea) return;

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow.document;

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Reservation Report</title>
          <style>
            @page {
              size: A4 landscape;
              margin: 15mm 100mm 15mm 45mm;
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
              margin: 0;
              padding: 0;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              border: 1px solid #000;
              padding: 6px;
            }

            .border-transparent,
            .border-transparent th,
            .border-transparent td {
              border: none !important;
            }

            .header {
              text-align: center;
              line-height: 1.3;
            }

            .header p {
              margin: 2px 0;
            }

            .text-center { text-align: center; }
            .text-end { text-align: right; }

            .table-print {
              margin: 0 15mm;
            }

            .area-print {
              margin: 5mm 15mm;
            }
          </style>
        </head>
        <body>
          ${printArea.innerHTML}
        </body>
      </html>
    `);
    doc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  };
</script>
